import React from 'react';

export const FilledSquare = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
  >
    <path
      d="M0 13.5278L50.4857 0.000222429L64.0133 50.4859L13.5276 64.0136L0 13.5278Z"
      fill="#044D29"
    />
    <text
      x="32.5"
      y="32.5"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize="28"
      fontWeight="bold"
      fill="white"
    >
      ✓
    </text>
  </svg>
);
